declare module '@mui/material/styles' {
	interface TypographyVariants {
		h1Medium?: React.CSSProperties;
		h1Bold?: React.CSSProperties;
		h2SemiBold?: React.CSSProperties;
		h3Medium?: React.CSSProperties;
		bodyMedium?: React.CSSProperties;
		bodySemiBold?: React.CSSProperties;
		bodyBold?: React.CSSProperties;
		title: React.CSSProperties;
		inputLabel: React.CSSProperties;
		largeButton: React.CSSProperties;
		placeholder: React.CSSProperties;
		captionMedium: React.CSSProperties;
	}

	// allow configuration using `createTheme`
	interface TypographyVariantsOptions {
		h1Medium?: React.CSSProperties;
		h1Bold?: React.CSSProperties;
		h2SemiBold?: React.CSSProperties;
		h3Medium?: React.CSSProperties;
		bodyMedium?: React.CSSProperties;
		bodySemiBold?: React.CSSProperties;
		bodyBold?: React.CSSProperties;
		title?: React.CSSProperties;
		inputLabel?: React.CSSProperties;
		largeButton?: React.CSSProperties;
		placeholder?: React.CSSProperties;
		captionMedium?: React.CSSProperties;
	}
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
	interface TypographyPropsVariantOverrides {
		h1Medium: true;
		h1Bold: true;
		h2SemiBold: true;
		h3Medium: true;
		bodyMedium: true;
		bodySemiBold: true;
		bodyBold: true;
		title: true;
		inputLabel: true;
		largeButton: true;
		placeholder: true;
		captionMedium: true;
	}
}

export default {
	fontFamily: ['Proxima Nova', 'Helvetica Neue'].join(','),
	title: {
		//title
		fontSize: '2.5rem',
		fontWeight: 400,
		lineHeight: 1.2,
	},
	h1: {
		fontSize: '2rem',
		fontWeight: 400,
		lineHeight: 1.2,
	},
	h1Medium: {
		fontSize: '2rem',
		fontWeight: 500,
		lineHeight: 1.2,
	},
	h1Bold: {
		fontSize: '2rem',
		fontWeight: 700,
		lineHeight: 1.2,
	},
	h2: {
		fontSize: '1.5rem',
		fontWeight: 400,
		lineHeight: 1.3,
	},
	h2SemiBold: {
		fontSize: '1.5rem',
		fontWeight: 600,
		lineHeight: 1.3,
	},
	h3: {
		fontSize: '1.25rem',
		fontWeight: 400,
		lineHeight: 1.4,
	},
	h3Medium: {
		fontSize: '1.25rem',
		fontWeight: 500,
		lineHeight: 1.4,
	},
	h4: {
		fontSize: '1.0rem',
		fontWeight: 400,
		lineHeight: 1.4,
	},
	h4Medium: {
		fontSize: '1.0rem',
		fontWeight: 500,
		lineHeight: 1.4,
	},
	body1: {
		fontSize: '1rem',
		fontWeight: 400,
		lineHeight: 1.4,
	},
	bodyMedium: {
		fontSize: '1rem',
		fontWeight: 500,
		lineHeight: 1.4,
	},
	bodySemiBold: {
		fontSize: '1rem',
		fontWeight: 600,
		lineHeight: 1.4,
	},
	bodyBold: {
		fontSize: '1rem',
		fontWeight: 700,
		lineHeight: 1.4,
	},
	largeButton: {
		// fontSize: '1.125rem',
		fontSize: '1rem',
		fontWeight: 500,
		lineHeight: 1.4,
	},
	button: {
		// medium buttons
		fontSize: '1rem',
		fontWeight: 500,
		lineHeight: 1.4,
		textTransform: 'none' as any,
	},
	placeholder: {
		fontSize: '1rem',
		fontWeight: 500,
		lineHeight: 1.5,
	},
	inputLabel: {
		fontSize: '0.75rem',
		fontWeight: 500,
		lineHeight: 1,
	},
	caption: {
		fontSize: '0.75rem',
		fontWeight: 400,
		lineHeight: 1.5,
	},
	captionMedium: {
		fontSize: '0.75rem',
		fontWeight: 500,
		lineHeight: 1.5,
	},
};
